module.exports = __webpack_public_path__ + "static/nyoutritious-4-936e7883ad061acfa02d4a1601d08f13.png";